import { render } from "./declined-message.vue?vue&type=template&id=4cae1714&scoped=true"
import script from "./declined-message.vue?vue&type=script&lang=js"
export * from "./declined-message.vue?vue&type=script&lang=js"

import "./declined-message.vue?vue&type=style&index=0&id=4cae1714&scoped=true&lang=css"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cae1714"]])

export default __exports__